import { faDumbbell } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialPropertyForSaleListing,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableRow } from '@unreserved-frontend-v2/ui/details-table/models'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'

export const useAmenitiesRow = (listing: ResidentialPropertyForSaleListing): DetailsTableRow | undefined => {
  const { t } = useTranslation()
  return useMemo(() => {
    const details = listing.propertyDetails as ResidentialApartmentPropertyDetails

    if (!details?.amenityRaw) {
      return
    }

    return {
      icon: faDumbbell,
      title: t('listings:details-pages.amenities'),
      cells: [
        {
          id: 'amenities',
          cellClassName: 'col-span-4',
          data: [
            {
              id: 'data-amenities',
              type: 'basic',
              value: details?.amenityRaw,
            },
          ],
        },
      ],
    }
  }, [t, listing])
}
